<script setup lang="ts">
import { faPause, faPlay, faXmark } from '@fortawesome/pro-solid-svg-icons'
import { DialogClose, DialogContent, DialogDescription, DialogPortal, DialogRoot, DialogTitle } from 'reka-ui'

const { episodes } = defineProps<{ episodes: PodcastRssEpisode[] }>()

const activeMedia = useActiveMedia()

const episode = computed(() => episodes.find(ep => ep.enclosure.url === activeMedia.value?.src))

const open = defineModel<boolean>('open', {
  default: false,
})

watch(activeMedia, (value) => {
  open.value = !!value
})

watch(open, (value) => {
  if (!value) {
    activeMedia.value?.pause()
  }
})
</script>

<template>
  <MediaControls v-slot="{ isPlaying }" :media="activeMedia">
    <DialogRoot v-model:open="open" :modal="false">
      <DialogPortal>
        <DialogContent
          class="fixed z-10 bottom-0 w-full bg-blurple-500 rounded-t-4xl pt-5 pb-16 px-7 flex justify-between items-start lg:hidden"
          @interact-outside.prevent
        >
          <DialogDescription class="flex flex-col gap-4 text-moss-200 grow">
            <DialogTitle class="flex gap-2.5 text-white">
              <PodcastEpisodeImage :episode="episode" />
              <PodcastEpisodeTitle :episode="episode" class="md:self-center" />
            </DialogTitle>

            <div class="flex w-full items-center gap-4">
              <MediaPlayButton>
                <Icon :icon="isPlaying ? faPause : faPlay" />
              </MediaPlayButton>
              <MediaTimeline theme="moss" size="thick" />
              <MediaTimestamp type="duration" />
            </div>
          </DialogDescription>
          <DialogClose class="text-white">
            <Icon :icon="faXmark" />
          </DialogClose>
        </DialogContent>
      </DialogPortal>
    </DialogRoot>
  </MediaControls>
</template>
